/* eslint-disable import/prefer-default-export */
export const LIST_INSURANCES = 'LIST_INSURANCES';
